import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { addAssignment } from '../../../../redux';
import Checkbox from 'material-ui/Checkbox';
import DatePicker from 'material-ui/DatePicker';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { Link, useNavigate } from 'react-router-dom';
import "../index.css";

function AssignmentForm (props) {
    const navigate = useNavigate();
    const [state, setState] = useState({
        name: "",
        dueDate: null,
        evaluationsRequired: null,
        status: null,
        errMsg: "",
        allowResubmissions: false
    });

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleChange = (e) => {
        setState({
            ...state,
            [e.target.name]: e.target.value
        });
    }

    const handleDateChange = (e, dueDate) => {
        setState({
            ...state,
            dueDate
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (state.name === "" ||
            state.dueDate === null ||
            state.evaluationsRequired === null ||
            state.status === null) {
            setState({
                ...state,
                errMsg: "Please fill out all the fields."
            })
        } else {
            props.addAssignment(
                {
                    name: state.name,
                    dueDate: state.dueDate,
                    status: state.status,
                    evaluationsRequired: state.evaluationsRequired,
                    sprint: props.classObject.currentSprint,
                    class: props.classObject._id,
                    allowResubmissions: state.allowResubmissions
                },
                props.assignments
            );
            setState({
                ...state,
                errMsg: ""
            });
            navigate("/teacher")
        }
    }

    const handleDropdownChange = (e) => {
        setState({
            ...state,
            status: e.target.innerText.trim()
        });
    }

    const handleResubmissionsChange = (e) => {
        setState({
            ...state,
            allowResubmissions: e.target.checked
        });
    }

    return (
        <div className="assignmentForm">
            <Link to="/teacher" className="backButton">
                <img src={require("../../../../Images/leftArrow.png")} alt="<-"/>
                Return to Dashboard
            </Link>
            <h1>Create New Assignment</h1>
            <TextField
                hintText="Assignment Title"
                name="name"
                onChange={handleChange}
                value={state.name}
                style={{paddingTop: "0px", paddingBottom: "20px"}}
            />
            <br/>
            <DatePicker
                hintText="Due Date"
                textFieldStyle={{paddingTop: "0px", paddingBottom: "20px"}}
                onChange={handleDateChange}
                value={state.dueDate}
            />
            <TextField
                hintText="# of Evaluations Required"
                name="evaluationsRequired"
                onChange={handleChange}
                value={state.evaluationsRequired}
                style={{paddingTop: "0px", paddingBottom: "20px"}}
                type="number"
            />
            <br/>
            <SelectField
                hintText={"Status"}
                name="status"
                value={state.status}
                onChange={handleDropdownChange}
                labelStyle={{textAlign: "left"}}
                floatingLabelStyle={{paddingLeft: "0%"}}
                style={{textAlign: "left", marginTop: "-10px"}}
            >
                <MenuItem
                    key="Inactive"
                    value="Inactive"
                    primaryText="Inactive"
                    id="status"
                />
                <MenuItem
                    key="Assigned"
                    value="Assigned"
                    primaryText="Assigned"
                    id="status"
                />
                <MenuItem
                    key="Reviewed"
                    value="Reviewed"
                    primaryText="Reviewed"
                    id="status"
                />
                <MenuItem
                    key="Graded"
                    value="Graded"
                    primaryText="Graded"
                    id="status"
                />
            </SelectField>
            <br/>
            <Checkbox
                label="Allow Resubmissions"
                checked={state.allowResubmissions}
                onCheck={handleResubmissionsChange}
                style={{maxWidth: "240px", margin: "0 auto"}}
            />
            <br/>
            <form onSubmit={handleSubmit}>
                <button type="submit" className="pink saveButton">Save</button>
            </form>
            <p className="errorMessage">{state.errMsg}</p>
        </div>
    );
}

export default connect(state => state.root, { addAssignment })(AssignmentForm);
